import { CheckboxField } from '@mgmresorts/wcl-core';
import { Typography } from '@mgmresorts/wcl-lab';
import React, { useCallback, useMemo } from 'react';

import { CONTACT_US_URL } from '../../../../config/config.app';
import { BindCheckbox } from '../../../../hooks/useCheckbox';
import { useContent } from '../../../../hooks/useContent';
import { Link } from '../../Link';
import { Separator } from '../../Separator';

import { StyledContent } from './StyledContent';

type CanadianOptInProps = BindCheckbox & {
  disabled?: boolean;
  onContactUsClick?: () => void;
};

export function CanadianOptIn({ onContactUsClick, ...props }: CanadianOptInProps) {
  const { getContentByPath } = useContent();

  const contactUsClick = useCallback(
    e => {
      e.preventDefault();
      e.stopPropagation();
      onContactUsClick && onContactUsClick();
      window.open(CONTACT_US_URL);
    },
    [onContactUsClick],
  );

  const [subHeaderPreLink, subHeaderPostLink] = useMemo(
    () => getContentByPath<string>('shared.fields.canadianOptIn.subHeader').split('%mgmResorts%'),
    [getContentByPath],
  );

  const mgmResorts = useMemo(
    () => getContentByPath<string>('shared.fields.canadianOptIn.mgmResorts'),
    [getContentByPath],
  );

  const renderPolicyContent = useCallback(() => {
    const [optInPreLink, optInPostLink] = getContentByPath<string>('shared.fields.canadianOptIn.optIn').split(
      '%mgmResorts%',
    );
    return (
      <Typography variant='paragraph'>
        {optInPreLink}
        <Link href={CONTACT_US_URL} onClick={contactUsClick} data-testid='canadian-optin-contact-us'>
          {mgmResorts}
        </Link>
        {optInPostLink}
      </Typography>
    );
  }, [contactUsClick, getContentByPath, mgmResorts]);

  return (
    <StyledContent data-testid='canadian-optin'>
      <Typography variant='h5' className='identity__for-canadians-header'>
        {getContentByPath<string>('shared.fields.canadianOptIn.header')}
      </Typography>
      <Typography variant='paragraph' className='identity__for-canadians-sub-header' testId='canadian-optin-content'>
        {subHeaderPreLink}
        <Link href={CONTACT_US_URL} onClick={contactUsClick}>
          {mgmResorts}
        </Link>
        {subHeaderPostLink}
      </Typography>
      <CheckboxField label={renderPolicyContent()} labelPlacement='right' id='canadianOnpIn' {...props} />
      <Separator />
    </StyledContent>
  );
}
